<template>
  <ManageRegionsTemplateForm
    v-if="data"
    :data="data"
    hasType
    :regionsEndPoint="regionsEndPoint"
    :textData="textData"
    :validationData="validationData"
  />
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import { useShaftV2Station } from '@/functions/use_remote_object';

// Components
import ManageRegionsTemplateForm from '@/components/form/hme_manage_regions_template.vue';

const props = defineProps({
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
  stationId: { type: String, required: false, default: '' },
});

const data = useShaftV2Station(props);

const regionsEndPoint = computed(() => {
  return `/organisations/${props.organisationId}/shafts_v2/shafts/${props.shaftId}/stations/${props.stationId}/station_regions`;
});

const validationData = {
  operation: 'station',
  operation_region: 'station_region',
  operation_regions: 'station_regions',
};

const textData = {
  pending_tile_process: {
    title: I18n.t('shafts.group.stations.diagram_loading_title'),
    description: I18n.t('shafts.group.stations.diagram_loading_description'),
  },
  no_diagram: {
    title: I18n.t('shafts.group.stations.no_station_diagram.title'),
    description: I18n.t('shafts.group.stations.no_station_diagram.message'),
  },
};
</script>
<style scoped lang="scss">
@import '@/stylesheets/global';
.current-item-name {
  margin: bu(1.8) bu(2);
}
</style>
